import React from "react";
import "../styles/Skills.css";

const skills = [
  {
    title: "Languages",
    items: [
      "Python",
      "JavaScript",
      "TypeScript",
    ],
  },
  {
    title: "Frontend",
    items: [
      "React",
      "Next.js",
      "HTML",
      "CSS",
      "Tailwind CSS",
    ],
  },
  {
    title: "Mobile Development",
    items: [
      "React Native",
    ],
  },
  {
    title: "AI & Computer Vision",
    items: [
      "OpenCV",
      "Machine Learning",
      "Speech Recognition",
    ],
  },
  {
    title: "Tools",
    items: [
      "Git",
      "GitHub",
      "Linux",
      "Docker",
    ],
  },
];

const Skills = () => {
  return (
    <section id="skills" className="skills">
      <h2>Skills & Technologies</h2>

      <p className="subtitle">
        Technologies and tools I use to build software.
      </p>

      <div className="skills-grid">
        {skills.map((skill) => (
          <div className="skill-card" key={skill.title}>
            <h3>{skill.title}</h3>

            <div className="skill-tags">
              {skill.items.map((item) => (
                <span key={item}>
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;